module.exports = __webpack_public_path__ + "img/shebei2.2c26d07c.png";